import {config} from '../config';

export default {
    getBleFwuDisabled: (deviceType) => config.data.fwu.bleFwuDisabled?.includes(deviceType),
    getAreNewFwuPopupsEnabled: () => config.data.fwu.areNewPopupsEnabled,
    getFwuReconnectAnimationVideo: () => config.data.fwu.reconnectAnimationVideo,
};
